import axios from "axios";
import { toast } from "react-toastify";
import React, {useState,useEffect} from "react";
import { Col, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ArticleView from "../CommonComponent/ArticleView";
import { loader } from "../../loader";
import { ENDPOINT } from "../../axios/apiConfig";
import { postData } from "../../axios/apiHelper";
import { useSidebar } from "../CommonComponent/LoginLayout";
import FilterDropdown from "../CommonComponent/FilterDropdown";
import ActiveFilter from "../CommonComponent/ActiveFilter";

const EventOnDemandContent = () => {
    let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
    const navigate = useNavigate();
    const { state } = useLocation();
    const { eventIdContext } = useSidebar();
    const eventId = state?.eventId ? state?.eventId : eventIdContext?.eventId ? eventIdContext?.eventId : JSON.parse(localStorage.getItem("EventIdContext"))?.eventId;
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [dataFetchInProcess, setDataFetchInProcess] = useState(false);
    const [articleListData, setArticleListData] = useState([]);
    const [pdfSelected, setPdfSelected] = useState([]);
    const [currentSelectedSublink,setCurrentSelectedSublink]=useState("")
    const [showFilter, setShowFilter] = useState(false);
    const [filters, setFilters] = useState({});
    const [allFilters, setAllFilters] = useState({});

    useEffect(() => {
        if (searchTerm.trim() === "" || Object.keys(filters).length > 0) {
            getAllArticles(true);
        }
    }, [filters,searchTerm]);

    const getAllArticles = async (reset = false) => {
        if (reset) {
            setPage(1);
            setArticleListData([]);
        }
        setDataFetchInProcess(true);
        loader("show");

        const body = {
            user_id: localStorage.getItem("user_id"),
            search: searchTerm,
            sublink: 1,
            filter: filters,
        };

        const articlesRequest = axios.post(`emailapi/get_content_list?page=${reset ? 1 : page}`, body);

        let filtersRequest = null;
        if (!allFilters || Object.keys(allFilters).length === 0) {
            filtersRequest = axios.post(`emailapi/get-content-filters`, { user_id: body.user_id });
        }

        try {
            let articlesRes, filtersRes;
            if (filtersRequest) {
                [articlesRes, filtersRes] = await Promise.all([articlesRequest, filtersRequest]);
            } else {
                articlesRes = await articlesRequest;
            }
            const newData = articlesRes?.data?.response?.data || [];
            setArticleListData(newData);

            if (filtersRes) {
                const filterData = filtersRes?.data?.response?.filter || [];
                setAllFilters(filterData);
            }
            setPage((prev) => prev + 1);
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong");
        } finally {
            setDataFetchInProcess(false);
            loader("hide");
        }
    };

    const handleSelect = (id) => {
        setPdfSelected([id])
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (!searchTerm.trim() || searchTerm.trim().length < 3) {
            toast.warning("Please enter at least 3 characters to search");
            return;
        }
        getAllArticles(true);
    };

    const addAgenda = async() => {
        try{
            loader("show")
            const payload = {
                "event_id":eventId,
                "pdf_id" : pdfSelected ? pdfSelected?.[0] : 0,
                "sublink_id" : currentSelectedSublink ? currentSelectedSublink : 0,
                "type" : "2"
            }
            await postData(ENDPOINT.AddAGENDA, payload);
        }catch(err){
            console.log(err)
        }finally{
            loader("hide")
        }
        navigate("/webinar/event/on-demand")
    }

    const handleRemoveFilter = (key, value) => {
        setFilters((prev) => ({
            ...prev,
            [key]: prev[key].filter((v) => v !== value),
        }));
    };

    const clearFilter = () => {
        const cleared = Object.fromEntries(
            Object.keys(filters).map((key) => [key, []])
        );
        setFilters(cleared);
    };

  return (
    <>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
      <Col className="right-sidebar custom-change event-collection">
        <div className="custom-container">
          <div className="row">

            <div className="top-header regi-web sticky">
              <div className="page-title">
                <h3>Add On-demand content</h3>
              </div>
              <div className="top-right-action">
                  <div className="action-btn-add" style={{ margin: "0" }}>
                    
                  </div>
                    <div className="header-btn">
                        <Link className="btn btn-primary btn-bordered move-draft" 
                            to="/webinar/event/on-demand">
                            Cancel
                        </Link>
                        <Button className= {`btn btn-primary btn-filled next ${pdfSelected?.length > 0 ? "" : "disabled"}`} onClick={addAgenda}>
                            Add
                        </Button>
                    </div>
                </div>
            </div>

            <div className="top-header add-agenda">
                <div className="page-title"><h4>Choose the content you want to assign as this event’s on-demand content</h4></div>
                <div className="top-right-action flex-wrap">
                    <div className="search-bar">
                        <form className="d-flex" onSubmit={handleSearchSubmit}>
                            <input
                                className="form-control me-2"
                                type="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button className="btn btn-outline" type="submit" disabled={!searchTerm.trim()}>
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15.8045 14.862L11.2545 10.312C12.1359 9.22334 12.6665 7.84 12.6665 6.33334C12.6665 2.84134 9.82522 0 6.33325 0C2.84128 0 0 2.84131 0 6.33331C0 9.82531 2.84132 12.6667 6.33328 12.6667C7.83992 12.6667 9.22325 12.136 10.3119 11.2547L14.8619 15.8047C14.9919 15.9347 15.1625 16 15.3332 16C15.5039 16 15.6745 15.9347 15.8045 15.8047C16.0652 15.544 16.0652 15.1227 15.8045 14.862ZM6.33328 11.3333C3.57597 11.3333 1.33333 9.09066 1.33333 6.33331C1.33333 3.57597 3.57597 1.33331 6.33328 1.33331C9.0906 1.33331 11.3332 3.57597 11.3332 6.33331C11.3332 9.09066 9.09057 11.3333 6.33328 11.3333Z"
                                        fill="#97B6CF"
                                    ></path>
                                </svg>
                            </button>
                        </form>
                    </div>

                    <div className={showFilter ? "filter-by nav-item dropdown highlight" : "filter-by nav-item dropdown"}>
                        <button
                            className="btn btn-secondary dropdown"
                            type="button"
                            id="dropdownMenuButton2"
                            onClick={() => setShowFilter((prev) => !prev)}
                        >
                            Filter By
                            {showFilter ? (
                                <svg
                                    className="close-arrow"
                                    width="13"
                                    height="12"
                                    viewBox="0 0 13 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        width="2.09896"
                                        height="15.1911"
                                        rx="1.04948"
                                        transform="matrix(0.720074 0.693897 -0.720074 0.693897 11.0977 0)"
                                        fill="#0066BE"
                                    />
                                    <rect
                                        width="2.09896"
                                        height="15.1911"
                                        rx="1.04948"
                                        transform="matrix(0.720074 -0.693897 0.720074 0.693897 0 1.45898)"
                                        fill="#0066BE"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    className="filter-arrow"
                                    width="16"
                                    height="14"
                                    viewBox="0 0 16 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M0.615385 2.46154H3.07692C3.07692 3.14031 3.62892 3.69231 4.30769 3.69231H5.53846C6.21723 3.69231 6.76923 3.14031 6.76923 2.46154H15.3846C15.7243 2.46154 16 2.18646 16 1.84615C16 1.50585 15.7243 1.23077 15.3846 1.23077H6.76923C6.76923 0.552 6.21723 0 5.53846 0H4.30769C3.62892 0 3.07692 0.552 3.07692 1.23077H0.615385C0.275692 1.23077 0 1.50585 0 1.84615C0 2.18646 0.275692 2.46154 0.615385 2.46154Z"
                                        fill="#97B6CF"
                                    ></path>
                                    <path
                                        d="M15.3846 6.15362H11.6923C11.6923 5.47485 11.1403 4.92285 10.4615 4.92285H9.23077C8.552 4.92285 8 5.47485 8 6.15362H0.615385C0.275692 6.15362 0 6.4287 0 6.76901C0 7.10931 0.275692 7.38439 0.615385 7.38439H8C8 8.06316 8.552 8.61516 9.23077 8.61516H10.4615C11.1403 8.61516 11.6923 8.06316 11.6923 7.38439H15.3846C15.7243 7.38439 16 7.10931 16 6.76901C16 6.4287 15.7243 6.15362 15.3846 6.15362Z"
                                        fill="#97B6CF"
                                    ></path>
                                    <path
                                        d="M15.3846 11.077H6.76923C6.76923 10.3982 6.21723 9.84619 5.53846 9.84619H4.30769C3.62892 9.84619 3.07692 10.3982 3.07692 11.077H0.615385C0.275692 11.077 0 11.352 0 11.6923C0 12.0327 0.275692 12.3077 0.615385 12.3077H3.07692C3.07692 12.9865 3.62892 13.5385 4.30769 13.5385H5.53846C6.21723 13.5385 6.76923 12.9865 6.76923 12.3077H15.3846C15.7243 12.3077 16 12.0327 16 11.6923C16 11.352 15.7243 11.077 15.3846 11.077Z"
                                        fill="#97B6CF"
                                    ></path>
                                </svg>
                            )}
                        </button>
                    </div>
                    {showFilter && (
                        <FilterDropdown
                            allFilters={allFilters}
                            filters={filters}
                            setFilters={setFilters}
                            onApply={(applied) => { setFilters(applied) }}
                            setShowFilter={setShowFilter}
                        />
                    )}
                </div>
            </div>

            <ActiveFilter
                filters={filters}
                onRemove={handleRemoveFilter}
                clearFilter={clearFilter}
            />

            <div className="email-result ">
                <div className="col email-result-block library-content-box-layout">
                    <div className="mail_trigger_right_dummy w-100">
                        {
                            articleListData?.length > 0 ?
                            <ArticleView
                                articleData = {articleListData}
                                primaryLink = {1}
                                is_selectable = {1}
                                pdfSelected={pdfSelected}
                                onPdfToggle={handleSelect}
                                selectedSublink = {currentSelectedSublink}
                                setCurrentSelectedSublink = {setCurrentSelectedSublink}
                            /> :
                            !dataFetchInProcess ?
                            <div className="no_found"><p>No Data Found</p></div>
                            : null
                        }

                        {
                            page <= 2 && articleListData.length > 29  && (
                                <button onClick={() => getAllArticles(false)} className="btn btn-primary load-more">
                                    Load More
                                </button>
                            )
                        }
                    </div>
                </div>
            </div>
          </div>
        </div>
      </Col>
    </>
  );
};
export default EventOnDemandContent;
